<template>
	<div class="creation-wizard-step-wrp display-flex flex-wrap width-100 flex-column">
		<div class="creation-wizard-step-header">
			<slot name="header" />
		</div>
		<v-divider class="divider" />
		<div class="creation-wizard-step-content flex-1">
			<slot />
		</div>
	</div>
</template>

<script>
export default {
	name: 'CreationWizardStepWrapper',
};
</script>

<style lang="scss" scoped>
@import '../assets/creation-wizard-vars.scss';
.creation-wizard-step-wrp {
	.creation-wizard-step-header,
	.creation-wizard-step-content {
		padding: $vertical-padding $horizontal-padding;
	}
	.divider {
		border-color: #eff2f9;
	}
}
</style>
